import { render, staticRenderFns } from "./tm-menu-page.vue?vue&type=template&id=25693545&scoped=true&"
import script from "./tm-menu-page.vue?vue&type=script&lang=ts&"
export * from "./tm-menu-page.vue?vue&type=script&lang=ts&"
import style0 from "./tm-menu-page.vue?vue&type=style&index=0&id=25693545&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25693545",
  null
  
)

export default component.exports